export default {"src":"/_next/static/media/museum.03e316e4.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};